const initShortlistsProvider = (apiUrl, httpClient, defaultCrudHandler) => {
  return (type, resource, params) => defaultCrudHandler(type, resource, params);
};

export default initShortlistsProvider;
